import { BaseNumberIdDataDto } from '../../../classes/common';
export class BranchDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.phoneNumber = initializer.phoneNumber;
    }
}
